<template>
  <div style="min-height:100vh">
    <div class="normal-header">
      <div class="normal-header-inner">
        <img src="../assets/imgs/航眼logo/蓝色@2x.png">
        <ul>
          <li @click="toHome()">首页</li>
          <li><span v-for="(item,index) in industryConfig.name" :key="index">{{ item}}<label v-if="index + 1 < industryConfig.name.length">></label></span></li>
          <!-- <li class="active">{{ title }}</li> -->
        </ul>
      </div>
    </div>
    <div class="img_box">
      <img src="../assets/imgs/article1@2x.png">
      <img src="../assets/imgs/article2@2x.png">
    </div>

    <div class="article-center">
      <div class="inner_left">
        <!-- 富文本显示 -->
        <div class="article_inner">
          <h4>{{articleObj.title}}</h4>
          <p><img src="../assets/imgs/from.png">{{articleObj.source}}
            <img src="../assets/imgs/time.png">
            {{ articleObj.date }}
            <img src="../assets/imgs/read.png">
            {{ articleObj.readNumber }}
          </p>
          <div class="content" v-html="articleObj.content"></div>
          <ul class="download_ul">
            <li v-for="(item,index) in articleObj.file" :key="index">
              <p>{{ articleObj.title }}.{{item.split('.')[item.split('.').length - 1] }}</p>
              <a :href="baseUrl + item">下载附件</a>
              <!-- <img src="../assets/imgs/doc@2x.png">
            <img src="../assets/imgs/eps@2x.png">
            <img src="../assets/imgs/pdf@2x.png">
            <img src="../assets/imgs/ppt@2x.png"> -->
            </li>
          </ul>
        </div>
        <div class="next" v-if="nextArticleObj">
          <h2 @click="getDetail('next')">下一篇</h2>
          <h3>{{ nextArticleObj.title }}</h3>
          <p>{{ nextArticleObj.content }}</p>
          <span>{{ nextArticleObj.date }}</span>
        </div>
      </div>

      <div class="inner_right">
        <h2 class="title">最热标签</h2>
        <ul class="hot-labels" v-if="labelList.length > 0">
          <li v-for="(item,index) in labelList" :key="index" @click="jumpToList(item)">
            {{ item.name }}
          </li>
        </ul>
        <h6 v-else>暂无内容</h6>
        <h2 class="title">最热榜</h2>
        <ul class="hot-list" v-if="hotArticleList.length > 0">
          <li v-for="(item,index) in hotArticleList" :key="index" @click="getDetail('hot',item)">
            <div class="hot_img_box"><img :src="item.image ? item.image : require('../assets/imgs/default-img.png')"></div>
            <!-- <img :src="item.image"> -->
            <div>
              <p>{{ item.title }}</p>
              <span class="date">{{ item.date }}</span>
            </div>
            <img class="ranking_img" src="../assets/imgs/hot1@2x.png" v-if="index == 0">
            <img class="ranking_img" src="../assets/imgs/hot2@2x.png" v-else-if="index == 1">
            <span class="ranking_text text_blue" v-else-if="index == 2">3</span>
            <span class="ranking_text" v-else>{{ index + 1 }}</span>
          </li>
        </ul>
        <h6 v-else>暂无内容</h6>
      </div>
    </div>

    <div class="foot">
      <div class="foot-center">
        <ul class="footer-left">
          <li><img src="../assets/imgs/航眼logo/白色底部@2x.png"></li>
          <li><span>中航咨询（北京）有限公司</span><span style="margin-left:310px">运营管理研究网</span></li>
          <li><span>网址：<a href="http://www.avicc.cn/" target="_blank" style="cursor: pointer;color:#c9c9c9;">http://www.avicc.cn/</a></span><span style="margin-left:300px;">网址：<a href="http://omr.avicc.cn" target="_blank" style="cursor: pointer;color:#c9c9c9;">http://omr.avicc.cn</a></span></li>
          <li>地址：北京市朝阳区来广营诚盈中心5号楼1206</li>
          <li><span>友情链接：</span><span v-for="(item,index) in companyList" :key="index" style="padding-right:10px"><a :href="item.dictValue" target="_blank">{{ item.dictLabel }}</a></span></li>
        </ul>
        <ul class="code_box">
          <li>联系我们</li>
          <li>
            <p>联系人：胡老师</p>
            <p>联系方式：13611332189 <span style="padding-left: 10px;">固定电话：010-87096276-8016</span></p>
          </li>
        </ul>
      </div>
      <p class="icp">©2020 京ICP备19056510号&emsp;增值电信业务经营许可证： 京ICP备19056510号&emsp;</p>
    </div>
  </div>
</template>

<script>
import { apiGet } from "../assets/http";
// import { devServer } from "../../vue.config.js"
// const baseUrl = devServer.proxy["/dev-api"].target + "/dev-api";
const baseUrl = "/dev-api";
// import { Loading } from "element-ui";
// let loading = Loading.service({
//   lock: true,
//   fullscreen: true,
//   text: "Loading...",
//   // spinner: "el-icon-loading",
//   background: "#FFF",
// });
export default {
  data() {
    return {
      // loading,
      articleId: "",
      columnId: "",
      articleObj: {},
      nextArticleObj: {},
      labelList: [],
      hotArticleList: [],
      baseUrl,
      companyList: [],
      title: "",
    };
  },
  created() {
    // let obj = {};
    // if (Object.keys(this.$route.params).length != 0) {
    //   obj = this.$route.params;
    //   localStorage.setItem("local_article_obj", JSON.stringify(this.$route.params));
    // } else {
    //   obj = JSON.parse(localStorage.getItem("local_article_obj"));
    // }
    this.industryConfig = JSON.parse(sessionStorage.getItem("industryConfig"));
    console.log(this.industryConfig)
    this.articleId = this.$route.query.articleId;
    this.title = sessionStorage.getItem("headerTitle");
    // this.articleId = obj.articleId;
    // this.columnId = obj.columnId;
    this.getDetail();
  },
  mounted() {
    this.companyList = JSON.parse(sessionStorage.getItem("companyLink"));
    document.documentElement.scrollTop = 0;
  },
  methods: {
    getDetail(type, item) {
      if (type == "next") {
        this.articleId = this.nextArticleObj.articleId;
      } else if (type == "hot") {
        this.articleId = item.articleId;
      }
      apiGet("/business/web/" + this.articleId).then((res) => {
        this.columnId = res.data.currentArticle.columnId;
        this.articleObj = res.data.currentArticle;
        this.nextArticleObj = res.data.nextArticle;
        // loading.close();
        // industryConfigId: this.industryConfig.industryConfigId,
        apiGet("/business/web/getColumnHotArticle", {
          columnId: this.columnId,
          industryConfigId: this.industryConfig.industryConfigId,
          industryConfigType: this.industryConfig.industryConfigType,
        }).then((res) => {
          if (res.data.hotArticleList) {
            res.data.hotArticleList.forEach((item) => {
              if (item.image) {
                if (
                  item.image &&
                  (item.image[0].indexOf("http") == -1 ||
                    item.image[0].indexOf("https") == -1)
                ) {
                  item.image[0] = baseUrl + item.image;
                }
              }
          });
          }
          this.labelList = res.data.labelList || [];

          this.hotArticleList = res.data.hotArticleList;
          // loading.close();
        });
      });
    },
    // getNext() {
    //   this.articleId = this.nextArticleObj.articleId
    //   apiGet("/business/web/" + this.nextArticleObj.articleId).then((res) => {
    //     this.articleObj = res.data.currentArticle;
    //     this.nextArticleObj = res.data.nextArticle;
    //     // loading.close();
    //   });
    // },
    jumpToList(item) {
      apiGet("/business/web/webIndexSearch", { key: "", type: 1 }).then(
        (res) => {
          this.$router.push({
            path: "/detail",
            name: "detail",
            params: {
              labelIds: [item],
              type: 1,
              key: null,
              jumpType: "articleHot",
              list: res.data || [],
            },
          });
        }
      );
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped lang="less">
.foot-center {
  width: 1280px !important;
}
.title {
  font-size: 18px;
  font-family: 思源黑体 Normal;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}
.article_inner {
  margin-bottom: 20px;
  h4 {
    width: 100%;
    font-size: 32px;
    font-family: 思源黑体 Normal;
    font-weight: bold;
    color: #333333;
    line-height: 46px;
    margin-bottom: 15px;
  }
  p {
    font-size: 12px;
    font-family: 思源黑体 Normal;
    color: #999999;
    margin-bottom: 30px;
    img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
      margin-left: 30px;
    }
    img:nth-child(1) {
      margin-left: 0;
    }
  }
  .content {
    width: 100%;
  }
}
.inner_right h6 {
  width: 100%;
  color: #999999;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
}
.download_ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  li {
    width: calc((100% - 40px) / 3);
    height: 80px;
    padding: 20px;
    margin-right: 20px;
    margin-top: 20px;
    border: 1px solid #d4d4d4;
    p {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    a {
      color: #428bca;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  li:nth-child(3n) {
    margin-right: 0;
  }
  li:nth-child(-n + 3) {
    margin-top: 0;
  }
}
</style>
<style>
.content {
  font-family: "思源黑体 Normal";
}
.content img {
  /* width: 100% !important; */
  max-width:100% !important;
  clear:both !important;
}
.content #text {
  text-indent: 2em;
}
.code_box{
  margin-top: 90px;
  li{
    color: #aeaeae;
  }
}
</style>